import { ACCOUNT_FEATURE } from '@socialive/common';
import { useFeature } from '@socialive/features';
import PropTypes from 'prop-types';
import { broadcastStreamShape, heroStreamShape, routerLocationShape } from '~/helpers/propTypeShapes';
import BroadcastStreams from './BroadcastStreams';
import LegacyBroadcastStreams from './LegacyBroadcastStreams';

const BroadcastStreamsPicker = ({
  APIBaseURL,
  broadcast,
  location,
  newBroadcastTitle,
  streams,
  reAuth,
  reduceStreamCount,
  trackEvent,
  updateStreams,
}) => {
  const [, { enabled }] = useFeature(ACCOUNT_FEATURE.USER_ROLES);

  // TODO: clean up this picker and the legacy component, when user roles is enabled to all accounts
  const BroadcastStreamsComponent = enabled ? BroadcastStreams : LegacyBroadcastStreams;

  return (
    <BroadcastStreamsComponent
      APIBaseURL={APIBaseURL}
      broadcast={broadcast}
      location={location}
      newBroadcastTitle={newBroadcastTitle}
      streams={streams}
      reAuth={reAuth}
      reduceStreamCount={reduceStreamCount}
      trackEvent={trackEvent}
      updateStreams={updateStreams}
    />
  );
};

BroadcastStreamsPicker.propTypes = {
  APIBaseURL: PropTypes.string.isRequired,
  broadcast: broadcastStreamShape.isRequired,
  location: routerLocationShape.isRequired,
  newBroadcastTitle: PropTypes.string.isRequired,
  streams: PropTypes.arrayOf(heroStreamShape).isRequired,
  reAuth: PropTypes.func.isRequired,
  reduceStreamCount: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  updateStreams: PropTypes.func.isRequired,
};

export default BroadcastStreamsPicker;
